import React, { FC, useState } from 'react';
import {
  MoreHorizontalUniversal,
  MoreInfoOutlined,
  WarningOutlined,
} from '@duxton-web/icons';
import { Button, Modal } from '@duxton-web/ui';
import { Dropdown, Menu, notification, Typography } from 'antd';

import Service from '../../../lib/App';

import './MoreActionSection.css';

import { HTTP_STATUS } from '@/constants/http';
import { useRolloutContext } from '@/contexts/RolloutContext';

export interface MoreActionSectionProps {
  showingLatest: boolean;
  // rollout, hasActiveRollout, hasPendingRollout, isSaving now come from context
}

export interface MoreActionSectionStates {
  showDisableRolloutWarning: boolean;
}

const MoreActionSection: FC<MoreActionSectionProps> = ({ showingLatest }) => {
  // Get rollout and methods from context
  const { rollout, hasActiveRollout, hasPendingChanges, handleSaving } =
    useRolloutContext();
  const [showDisableRolloutWarning, setShowDisableRolloutWarning] =
    useState<boolean>(false);

  function formatErrorMessage(e: any) {
    if (e?.response?.data?.arg) {
      const message: string = e.response.data.arg;
      return message.toLowerCase().replace('\n', ', ');
    }
    return 'unknown error';
  }

  async function handleDisableRolloutOK() {
    setShowDisableRolloutWarning(false);

    try {
      await Service.planner!.disableRollout(rollout.variable);

      notification.success({
        description: `Rollout for variable  ${rollout.variable}
      was successfully Disabled`,
        message: 'Disable of rollout',
      });
      handleSaving(false, true);
    } catch (error) {
      let description = `Rollout was not disabled,
      due to: ${formatErrorMessage(error)}`;

      if (error?.response?.status === HTTP_STATUS.FORBIDDEN) {
        description =
          'Not enough permissions, only user with manageAccess to this variable can disable its rollout';
      }
      if (error?.response?.status === HTTP_STATUS.NOT_FOUND) {
        description =
          'This variable does not have a rollout configured currently or the Disable Rollout API does not exist yet';
      }
      notification.error({
        description,
        message: 'Disable of rollout failed',
      });
    }
  }

  function handleDisableRolloutCancel() {
    setShowDisableRolloutWarning(false);
  }

  function onClickMenu({ key }) {
    switch (key) {
      case 'ActionDisable':
        setShowDisableRolloutWarning(true);
    }
  }

  function renderMoreActionDropDown() {
    if (hasActiveRollout() && showingLatest) {
      let menu = (
        <Menu onClick={onClickMenu}>
          <Menu.Item key="ActionDisable" disabled={hasPendingChanges()}>
            Disable
          </Menu.Item>
        </Menu>
      );
      return (
        <div>
          <Dropdown overlay={menu}>
            <Button
              type="secondary"
              size="small"
              shape="circle"
              icon={<MoreHorizontalUniversal />}
              className="more-ation-button"
            />
          </Dropdown>
        </div>
      );
    }
  }

  return (
    <div
      style={{
        marginLeft: '8px',
      }}
    >
      {renderMoreActionDropDown()}
      {showDisableRolloutWarning && (
        <Modal
          title="Disable Rollout"
          okText="Disable"
          okButtonProps={{ danger: true, size: 'small' }}
          cancelButtonProps={{ size: 'small' }}
          open
          destroyOnClose
          onOk={handleDisableRolloutOK}
          onCancel={handleDisableRolloutCancel}
        >
          <WarningOutlined /> &nbsp; Are you sure that you want to disable all
          the rollout on this variable? <br />
          <br />
          After clicking{' '}
          <Typography.Text type="danger">Disable</Typography.Text>, all values
          returned from GetVariable call
          <br />
          will resolve to <Typography.Text code>
            Code Default
          </Typography.Text>{' '}
          in about 2 mins,
          <br />
          if no experiment is running on this variable.
          <br />
          <br />
          <MoreInfoOutlined /> &nbsp; This action is only permitted to user with
          manage access on this variable. eg. Variable owner, ManageAccess on
          the service or Administrator(GrabX).
          <br />
        </Modal>
      )}
    </div>
  );
};

export default MoreActionSection;
